import firebase from "datastore/database";
import store from "datastore/store";
import fetchDoc from "util/api/fetchDoc";

export const observeCourses = (businessUid) => {
  store.dispatch({ type: "ADD_COURSES_LOADING" });
  return firebase
    .firestore()
    .collection(`courses/business/${businessUid}`)
    .onSnapshot((doc) => {
      const courses = Object.create(null);
      doc.forEach((item) => (courses[item.id] = item.data()));
      store.dispatch({ type: "ADD_COURSES_SUCCESS", courses });
    });
};

export const observeDiscounts = (businessUid) => {
  store.dispatch({ type: "ADD_DISCOUNTS_LOADING" });
  return firebase
    .firestore()
    .collection(`discounts/business/${businessUid}`)
    .onSnapshot((doc) => {
      const discounts = Object.create(null);
      doc.forEach((item) => (discounts[item.id] = item.data()));
      store.dispatch({ type: "ADD_DISCOUNTS_SUCCESS", discounts });
    });
};

export const observeStaff = (businessUid) => {
  store.dispatch({ type: "ADD_STAFF_LOADING" });
  return firebase
    .firestore()
    .collection(`staff/business/${businessUid}`)
    .onSnapshot((doc) => {
      const staff = Object.create(null);
      doc.forEach((item) => (staff[item.id] = item.data()));
      store.dispatch({ type: "ADD_STAFF_SUCCESS", staff });
    });
};

export const fetchMenuItems = async (businessUid) => {
  store.dispatch({ type: "ADD_MENU_ITEMS_LOADING" });
  const menuItems = await fetchCollection(`menu-items/business/${businessUid}`);
  store.dispatch({ type: "ADD_MENU_ITEMS_SUCCESS", menuItems });
};

export const observeMenuItems = (businessUid) => {
  store.dispatch({ type: "ADD_MENU_ITEMS_LOADING" });
  return firebase
    .firestore()
    .collection(`menu-items/business/${businessUid}`)
    .onSnapshot((doc) => {
      const menuItems = Object.create(null);
      doc.forEach((item) => (menuItems[item.id] = item.data()));
      store.dispatch({ type: "ADD_MENU_ITEMS_SUCCESS", menuItems });
    });
};

export const observeMenus = (businessUid) => {
  store.dispatch({ type: "ADD_MENUS_LOADING" });
  return firebase
    .firestore()
    .collection(`menus/business/${businessUid}`)
    .onSnapshot((doc) => {
      const menus = Object.create(null);
      doc.forEach((item) => (menus[item.id] = item.data()));
      store.dispatch({ type: "ADD_MENUS_SUCCESS", menus });
    });
};

export const observeModifiers = (businessUid) => {
  store.dispatch({ type: "ADD_MODIFIERS_LOADING" });
  return firebase
    .firestore()
    .collection(`modifiers/business/${businessUid}`)
    .onSnapshot((doc) => {
      const modifiers = Object.create(null);
      doc.forEach((item) => (modifiers[item.id] = item.data()));
      store.dispatch({ type: "ADD_MODIFIERS_SUCCESS", modifiers });
    });
};

export const observeOrder = (businessUid, orderUid, callback) => {
  return firebase
    .firestore()
    .collection(`orders/business/${businessUid}`)
    .doc(orderUid)
    .onSnapshot(async (snapshot) => {
      const order = { uid: snapshot.id, ...snapshot.data() };
      const tabUid = order?.tabs?.[0];
      let tab = {};
      if (tabUid) {
        const tabDoc = await firebase
          .firestore()
          .collection(`tabs/business/${businessUid}`)
          .doc(tabUid)
          .get();
        tab = { uid: tabDoc.id, ...tabDoc.data() };
      }
      callback({ ...order, tabs: [tab] });
    });
};

export const observeOrders = (businessUid) => {
  store.dispatch({ type: "ADD_ORDERS_LOADING" });
  return firebase
    .firestore()
    .collection(`orders/business/${businessUid}`)
    .onSnapshot((snapshot) => {
      //First time this is called, every doc comes at once as "added". Batch these to prevent a ton of updates
      const updates = {
        added: [],
        modified: [],
        removed: [],
      };

      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          updates.added.push({ uid: change.doc.id, ...change.doc.data() });
        }
        if (change.type === "modified") {
          updates.modified.push({ uid: change.doc.id, ...change.doc.data() });
        }
        if (change.type === "removed") {
          updates.removed.push({ uid: change.doc.id, ...change.doc.data() });
        }
      });
      if (updates.added.length > 0)
        store.dispatch({ type: "ADD_ORDERS", data: updates.added });
      if (updates.modified.length > 0)
        store.dispatch({ type: "UPDATE_ORDERS", data: updates.modified });
      if (updates.removed.length > 0)
        store.dispatch({ type: "DELETE_ORDERS", data: updates.removed });
    });
};

export const observeSurcharges = (businessUid) => {
  store.dispatch({ type: "ADD_SURCHARGES_LOADING" });
  return firebase
    .firestore()
    .collection(`surcharges/business/${businessUid}`)
    .onSnapshot((doc) => {
      const surcharges = Object.create(null);
      doc.forEach((item) => (surcharges[item.id] = item.data()));
      store.dispatch({ type: "ADD_SURCHARGES_SUCCESS", surcharges });
    });
};

export const observeTaxes = (businessUid) => {
  store.dispatch({ type: "ADD_TAXES_LOADING" });
  return firebase
    .firestore()
    .collection(`taxes/business/${businessUid}`)
    .onSnapshot((doc) => {
      const taxes = Object.create(null);
      doc.forEach((item) => (taxes[item.id] = item.data()));
      store.dispatch({ type: "ADD_TAXES_SUCCESS", taxes });
    });
};

export const observeTabs = (businessUid) => {
  store.dispatch({ type: "ADD_TABS_LOADING" });
  return firebase
    .firestore()
    .collection(`tabs/business/${businessUid}`)
    .onSnapshot((doc) => {
      const data = Object.create(null);
      doc.forEach((item) => (data[item.id] = item.data()));
      store.dispatch({ type: "ADD_TABS_SUCCESS", tabs: data });
    });
};

export const getOrder = async (businessUid, orderUid) => {
  const order = await fetchDoc(`orders/business/${businessUid}/${orderUid}`);
  if (!order) return null;
  const tabPromises = order?.tabs?.map((tabUid) =>
    fetchDoc(`tabs/business/${businessUid}/${tabUid}`)
  );
  const tabs = await Promise.all(tabPromises);
  order.tabs = tabs;
  return order;
};

export default {
  observeCourses,
  observeDiscounts,
  observeMenuItems,
  observeMenus,
  observeModifiers,
  observeOrders,
  observeSurcharges,
  observeTabs,
  observeTaxes,
  observeStaff,
  getOrder,
};
